/* eslint-disable react/no-danger */
import dynamic from 'next/dynamic';
import { useGetDetailPost } from '@containers/Home/hook/useGetDetailPost';
import React, { memo } from 'react';
import { DialogPostWrapper } from './styled';
import { useTourEventState } from '@containers/Home/global/TourStats';
import { selectConfigPopupIntro } from '@containers/Home/selectors';
import { useSelector } from 'react-redux';

const DialogContainer = dynamic(() => import('@components/DialogContainer'));
const LoadingContainer = dynamic(() => import('@components/LoadingContainer'));

interface Props {
  idPost: string;
  visible: boolean;
  isUseDefaultStyle?: boolean;
  onCancel: () => void;
}

const DialogPost = ({
  idPost,
  visible,
  onCancel,
  isUseDefaultStyle = true,
}: Props) => {
  const [tourEventStats] = useTourEventState('state');
  const { detailPost, loading } = useGetDetailPost({ idPost });

  const configPopupIntro = useSelector(selectConfigPopupIntro);

  return tourEventStats.isVisiblePopupIntro &&
    configPopupIntro.type === 'post' &&
    configPopupIntro.mode === 'fullscreen' ? (
    <DialogPostWrapper className="popupIntro type-article mode-fullScreen">
      <div className="--contentWrapper">
        <div
          ref={ref => {
            if (
              ref &&
              detailPost &&
              tourEventStats.isVisiblePopupIntro &&
              configPopupIntro.type === 'post' &&
              configPopupIntro.mode === 'fullscreen'
            ) {
              const button =
                ref?.querySelector('.btn') || ref?.querySelector('.button');
              if (button) button.addEventListener('click', onCancel);
            }
          }}
          className="ctn__html sun-editor sun-editor-editable --content"
          dangerouslySetInnerHTML={{ __html: detailPost?.content || '' }}
        />
      </div>
      <div className="close" onClick={onCancel}>
        <i aria-hidden className="fal fa-times" />
      </div>
    </DialogPostWrapper>
  ) : (
    <DialogContainer
      visible={visible}
      onCancel={onCancel}
      maskClosable
      top={0}
      width="700px"
      // height="80%"
      centered
      bodyStyle={{ maxWidth: '700px', width: '100%' }}
    >
      <DialogPostWrapper
        isUseDefaultStyle={isUseDefaultStyle}
        isUseDefaultColor={
          tourEventStats.isVisiblePopupIntro && configPopupIntro.type === 'post'
        }
      >
        <LoadingContainer loading={loading}>
          <div className="header">
            {detailPost?.thumbnail?.src && (
              <img
                className="thumb"
                src={detailPost?.thumbnail?.src}
                alt={detailPost?.thumbnail?.name}
              />
            )}
            <div className="title">{detailPost?.title || 'N/A'}</div>
          </div>
          <div className="body hide-scrollbar">
            {detailPost?.content && (
              <div
                className="content ctn__html sun-editor sun-editor-editable"
                dangerouslySetInnerHTML={{ __html: detailPost?.content || '' }}
              />
            )}
          </div>
        </LoadingContainer>
      </DialogPostWrapper>
    </DialogContainer>
  );
};

export default memo(DialogPost);
